import ConfiguratorSurveyRenderResult from "@components/ConfiguratorSurveyRenderResult";
import ConfiguratorSurveyOutputRender from "@components/ConfiguratorSurveyOutputRender";
import React, {useContext} from "react";
import ConfiguratorContext from "@components/ConfiguratorContext";
import evaluateJsonOutputValue from "@utils/evaluateJsonOutputValue";

const ConfiguratorSurveyJsonOutputValue = ({
  output,
  role,
  realtime,
  ...rest
}) => {

  // context
  const context = useContext(ConfiguratorContext);

  // utilities
  const value = evaluateJsonOutputValue(output, context, rest.recursiveResponsesIndex);

  return (
    <ConfiguratorSurveyOutputRender {...output} role={role} realtime={realtime}>
      <ConfiguratorSurveyRenderResult
        result={value}
        currency={output.output_currency}
        realtime={realtime}
      />
    </ConfiguratorSurveyOutputRender>
  )
}

export default ConfiguratorSurveyJsonOutputValue;